export default __webpack_public_path__ + "static/media/arrow_right_alt.495d5942.svg";